<template>
  <div>
    <v-container grid-list-md class="ma-0 pa-2" fluid>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <v-select
              v-if="!loading && companies.length > 1"
              outlined
              :background-color="$vuetify.theme.themes[theme].menu"    
              :item-color="companyPrimaryColor"
              :color="companyPrimaryColor"
              :items="companies"
              item-text="name"
              item-value="id"
              v-on:input="loadActiveCompData()"
              v-model="activeComp"
              label="Select"
              single-line>
            </v-select>
          </v-flex>
        </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="loading == false" class="special-content-box">
      <v-card flat>
        <v-card-title>
          <v-text-field
            v-if="users.length > 0"
            style="max-width: 300px;"
            v-model="searchUsers"
            name="searchfield"
            label="Zoeken"
            prepend-inner-icon="search"
            clearable
            hide-details
            outlined
            single-line>
          </v-text-field>
        </v-card-title>

        <div v-if="filteredUsers.length === 0 && searchUsers.length > 0" style="padding: 50px; text-align: center;">
          Geen resultaten gevonden voor <strong>"{{ searchUsers }}"</strong>.
        </div>
        <div v-else-if="filteredUsers.length === 0 && searchUsers.length == 0" style="padding: 50px; text-align: center;">
          Geen Piggy gebruikers.
        </div>
        <div v-else>
          <v-data-table
            :headers="headers"
            :search="searchUsers"
            :items="users"
            :itemsPerPage.sync="piggyPages"
            hide-default-footer
            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
            <template v-slot:item="{item}">
              <tr>
                <td>{{ item.piggy.email}} </td>
                <td>{{ item.instagram }}</td>
                <td>
                  <span v-if="item[selectedYear + '_likes']">
                    {{ item[selectedYear + "_likes"].length }} <span v-if="item[selectedYear + '_likes'].length > 1">likes</span> <span v-if="item[selectedYear + '_likes'].length == 1">like</span>
                  </span>
                </td>
                <td>
                  <span v-if="item[selectedYear + '_comments']">
                    {{ item[selectedYear + "_comments"].length }} <span v-if="item[selectedYear + '_comments'].length > 1">comments</span> <span v-if="item[selectedYear + '_comments'].length == 1">comment</span>
                  </span>
                </td>
                <td>{{ item.lastUpdated.seconds | moment("D  MMMM YYYY h:MM") }}u</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import axios from "axios";
import platform from 'platform'; 

export default {

  name: "PiggySocial",

  data: () => ({
    loading: true,
    pagination: {
      sortBy: "lastUpdated.seconds",
      rowsPerPage: -1,
      descending: true
    },
    search: "",
    selectedYear: 2020,
    activeCompData: {
      apiItems: {
        drupal: false,
        salonhub: false
      },
      social: {
        facebook: false,
        facebookUrl: null
      }
    },
    piggyPages: -1,
    searchUsers: "",
    editUserInfo: {
      userPermissions: {}
    },
    editUserInfoOriginal: {},
    users: [],
    activeCompDataOriginal: {},
    showPassword: false,
    editUserDialog: false,
    newUserDialog: false,
    editUserDialog: false,
    removeBookings: "",
    editBranchDialog: false,
    newBranchDialog: false,
    selected: [],
    companies: [],
    branches: [],
    activeComp: "",
    userCompaniesAccess: "",
    salonhubApiFeedback: "",
    salonhubApiSuccess: "",
    salonhubApiCheck: "",
    salonhubApiAlert: false,
    salonhubApiAlertSuccess: false,
 
    headers: [
      {
        text: "E-mail",
        align: "left",
        value: "piggy.email"
      },
      {
        text: "Instagram Gebruikersnaam",
        align: "left",
        value: "instagram"
      },
      {
        text: "Likes",
        align: "left",
        value: "2020_likes.length"
      },
      {
        text: "Comments",
        align: "left",
        value: "2020_comments.length"
      },
      {
        text: "Datum",
        align: "left",
        value: "lastUpdated.seconds",
        width: "220px"
      }
    ],
  }),

  created() {
    this.loadUserComp();
  },


  methods: {
    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
        })
        .then(() => {
          this.loading = false;
          this.getPiggySocial();
        })
        .catch(error => {
          this.loading = false;
          console.log("Error getting document:", error);
        });
    },

    getPiggySocial() {
      this.loading = true;
      this.users = [];
      db.collection("clientSocial")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let user = doc.data();
            user.id = doc.id;
            this.users.push(user);
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },

  computed: {  
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    filteredUsers() {
      return this.users.filter(user => {
        let email = ""
        let instagram = ""
        if(user.piggy && user.piggy.email){
          email = user.piggy.email
        }
        if(user.instagram){
          instagram = user.instagram
        }
        return (
          instagram.toLowerCase().indexOf(this.searchUsers.toLowerCase()) >= 0 ||
          email.toLowerCase().indexOf(this.searchUsers.toLowerCase()) >= 0
        );
      });
    },
    
  }
};
</script>
